import React from 'react';
import { Icon } from '@iconify/react';
import bx from '@iconify-json/bx/icons.json';

/**
 * Decorative motion stays in CSS; the status reflects the actual request.
 * mode="loading" reuses the same scene for the campaign-build data fetch
 * (opportunity hydration) — same document animation, loading copy instead of
 * the language-route dressing.
 */
export function TranslationEffect({ language, mode = 'translating' }: { language: string; mode?: 'translating' | 'loading' }) {
  const loading = mode === 'loading';
  const languageName = new Intl.DisplayNames(['en'], { type: 'language' }).of(language) || language;
  return <div className="preview-translating-fx">
    <div className="ptx-ambient" aria-hidden="true" />
    <div className="ptx-content">
      <div className="ptx-scene" aria-hidden="true">
        <div className="ptx-orbit" />
        <div className="ptx-document ptx-document-back" />
        <div className="ptx-document ptx-document-front">
          <div className="ptx-document-heading"><Icon icon={{ ...bx.icons.file, width: 24, height: 24 }} /><span>REPORT</span><i /></div>
          <div className="ptx-document-lines"><i /><i /><i /><i /><i /><i /></div>
          <div className="ptx-scan" />
          <div className="ptx-document-footer"><span /><span /></div>
        </div>
        {!loading && <><span className="ptx-language-token ptx-language-source">Aa</span>
        <span className="ptx-language-token ptx-language-target">{language.toUpperCase()}</span></>}
        <span className="ptx-spark ptx-spark-one" /><span className="ptx-spark ptx-spark-two" />
      </div>
      <div className="ptx-eyebrow">{loading ? 'LIVE DATA' : 'A NEW LANGUAGE. YOUR VOICE.'}</div>
      <div role="status" aria-live="polite" aria-atomic="true">
        <h2 className="ptx-title">{loading ? 'Loading your report data' : 'Translating your report'}<span className="ptx-sr-only"> into {languageName}</span></h2>
        <p className="ptx-description">{loading ? 'Fetching the latest intelligence for this campaign.' : 'Thoughtful words. The same meaning.'}</p>
      </div>
      {!loading && <div className="ptx-language-route" aria-hidden="true"><span>Original</span><span className="ptx-route-line"><i /></span><span className="ptx-lang">{languageName}</span></div>}
      <div className="ptx-progress" aria-hidden="true"><span /></div>
      <p className="ptx-caption">{loading ? 'This takes a few seconds the first time.' : 'Your translated preview will appear here.'}</p>
    </div>
  </div>;
}
